<div class="flex items-center">
  <div class="md:block">
    <div
      id="tooltip"
      style="
        position: absolute;
        background-color: white;
        padding: 5px;
        border: 1px solid black;
        opacity: 0;
      "
    ></div>
    <figure id="map" class="overflow-hidden">
      <svg #svg [attr.width]="width" [attr.height]="height" class="w-full h-auto max-w-full">
        <g></g>
      </svg>
    </figure>
  </div>
</div>
